export default __webpack_public_path__ + "static/microphone_b.b14b3a160de555480927c7a88c52fdf4.png";